import AuthService from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/services/AuthService";
import { useCurrentUserRoles } from "@/hooks/useCurrentUserRoles";
import { useMemo } from "react";
import UnauthorizedScreen from "./UnauthorizedScreen";

type Props = {
  children: JSX.Element | JSX.Element[];
  expectedPermissions: string[]; // Any of these grants access (platform OR tenant role)
};

export function TenantAwareProtectedRoute({ children, expectedPermissions }: Props) {
  const tenantRoles = useCurrentUserRoles();
  const tenantPermissions = useMemo(() => new Set(tenantRoles.flatMap((r) => r.permissions.map((p) => p.uuid))), [tenantRoles]);

  const hasAccess = expectedPermissions.some((p) => AuthService.hasPermissionFor(p) || tenantPermissions.has(p));

  if (!hasAccess) return <UnauthorizedScreen />;
  return <>{children}</>;
}
